<template>
<div class="imglist" v-if="images[0]">
  <div class="perfundo" v-for="(image, index) in imglist" v-if="showImage(image)">
    <a class="perfundo__link" :href="imageRef(fid, index)">
      <img :src="image.thumb" :alt="image.label"></img>
    </a>
    <div class="perfundo__overlay fadeIn" :id="imageId(fid, index)">
      <figure class="perfundo__content perfundo__figure">
        <img :src="image.thumb" :alt="image.label"></img>
        <div class="perfundo__image">
          <img :src="image.href" :alt="image.label"></img>
        </div>
      </figure>
      <a class="perfundo__close perfundo__control" href="#perfundo-untarget">Schließen</a>
      <!--
      <a class="perfundo__next perfundo__control perfundo__link" v-if="image.next" :href="imageRef(fid, image.next)">Weiter</a>
      <a class="perfundo__prev perfundo__control perfundo__link" v-if="image.prev" :href="imageRef(fid, image.prev)">Zurück</a>
      -->
    </div>
  </div>
</div>
</template>

<script>
// .perfundo__image(v-bind:style='[imgStyles, {width: imgWidth, "padding-top": imgPaddingTop, "background-image": image.bgimg}]')
import Util from '../util.js';

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    baseUrl: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: function () {
        return [];
      }
    },
    imgWidth: {
      type: String,
      default: '800px'
    },
    imgPaddingTop: {
      type: String,
      default: '66.25%'
    },
    imgStyles: {
      type: Object,
      default: function() {
        return {};
      }
    },
    filter: {
      type: [String, RegExp]
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    fid() {
      return this.id == '' ? Util.uuid() : this.id;
    },
    filterPattern() {
      return new RegExp(this.filter);
    },
    imglist() {
      var url = '';
      if (this.baseUrl.substring(this.baseUrl.length - 1, this.baseUrl.length) == '/')
        url = this.baseUrl;
      else if (this.baseUrl != '')
        url = this.baseUrl + '/';

      var l = [];
      this.images.forEach(function(img, index) {
        index++;
        l.push({
          thumb: url + img + '.png',
          href: url + img + '.png',
          bgimg: 'url("' + url + img + '.png")',
          index: index,
          prev: index > 1 ? index - 1 : null,
          next: index < this.images.length ? (index + 1) : null,
          label: 'Img ' + index
        });
      }.bind(this));
      return l;
    },
    url() {
      if (this.baseUrl == '')
        return '';

      if (this.baseUrl.substring(this.baseUrl.length - 1, this.baseUrl.length) == '/')
        return this.baseUrl;

      return this.baseUrl + '/';
    }
  },
  methods: {
    imageRef(id, index) {
      return '#' + this.imageId(id, index);
    },
    imageId(id, index) {
      return id + '-img' + index;
    },
    showImage(image) {
      if (!this.filter && !this.limit) {
        return true;
      }

      if (this.filter) {
        return image.href.match(this.filterPattern);
      }

      return image.index <= this.limit;
    }
  }
}
</script>
